import ExceptionFilterBar from '../ExceptionFilterBar';
import ExceptionList from '../ExceptionList';

import ExceptionHeader from './ExceptionHeader';
import ExceptionLayout from './ExceptionLayout';
import useExceptionReport from './hooks';

const ExceptionPage = () => {
  const { exceptionReports, isLoading } = useExceptionReport();

  return (
    <ExceptionLayout>
      <div>
        <ExceptionHeader />
        <ExceptionFilterBar />
      </div>
      <ExceptionList exceptionReports={exceptionReports} loading={isLoading} />
    </ExceptionLayout>
  );
};

export default ExceptionPage;
